import { FC } from "react";
import { TbChevronRight } from "react-icons/tb";

interface Props {
  label: string;
  onClick: () => void;
}

export const NavigationButton: FC<Props> = ({ label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-between font-medium text-sm text-blueShades-4 hover:text-blueShades-5"
    >
      <span className="">{label}</span>
      <TbChevronRight className="block md:hidden" size={20} />
    </button>
  );
};
